module.exports = __webpack_public_path__ + "media/error2.8a2db22c.mp3";